import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Register from "./components/Register";

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <Switch>
                {/*<Route exact path="/" component={App}/>*/}
                <Route exact path="/reset" component={App}/>
                <Route exact path="/verify" component={Register}/>
            </Switch>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
